/* esm.sh - unhead@3.1.0/minify */
export * from "/*unhead@3.1.0/esnext/minify.mjs";
